/*
 * @Author: cq
 * @LastEditors: cq
 * @Date: 2025-03-24 16:32:36
 * @LastEditTime: 2025-06-06 10:21:08
 * @FilePath: \point-cloud-analysis\page\api\config.js
 */
/**
 * API接口配置文件
 * 集中管理所有接口，便于维护
 */

// 点云分析相关接口 (根据你的项目名来看，可能需要这类接口)
export const POINT_CLOUD_API = {
  UPLOAD: '/api/pointcloud/upload',           // 上传点云数据
  FRAGMENT_UPLOAD: '/api/pointcloud/fragmentUpload',    // 分片上传点云数据
  FIND_UPLOAD_STATUE: '/api/pointcloud/findByMd5',//上传文件之前用于查询当前文件是否已经上传过
  GET_BY_ID: '/api/pointcloud/get',           // 获取单个点云详情
  DELETE: '/api/pointcloud/delete',           // 删除点云数据
  ANALYZE: '/api/pointcloud/analyze',         // 分析点云数据
  EXPORT_RESULT: '/api/pointcloud/export',    // 导出分析结果
  SSE_ANALYZE: '/api/sse/connect/',  //sse实时获取点云文件切片进度
  POINT_CLOUD_LIST: "/api/pointcloud/list",//获取已经上传成功的点云列表
  POINT_CLOUD_HANDLE: "/api/pointcloud/handle",//点云处理接口
  // 提取点云的矢量文件
  EXTRACT_VECTOR: "/api/pointcloud/exportRailwayVector",
}

// 登录注册相关
export const USER_API = {
  LOGIN: '/api/login', // 登录
  REGISTER: '/api/register', // 注册
  // 获取验证码
  GET_CAPTCHA: '/api/captchaImage', // 获取验证码
LOGIN_OUT: '/api/logout', // 退出登录
}


// 导出所有API配置
export default {
  POINT_CLOUD_API,
  USER_API
}; 